import ReplaceArrows from '../../src/legacy/ReplaceArrows';
export default ReplaceArrows;
